<script>
    import { Grid, Text } from "@axel669/zephyr"
</script>

<Grid ws="gr.cols: 1fr 1fr; b: 1px solid hsl(@primary, @layer-border);">
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">Content</Text>
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">More content</Text>
    <Text ws="p: 4px; b: 1px solid hsl(@success, @layer-border);">Event more content</Text>
</Grid>
